import React, { useEffect } from 'react';
import { OnboardingHeader } from '@features/onboarding/components/onboarding-header/OnboardingHeader';
import { OnboardingForm } from '@features/onboarding/OnboardingForm';

const MainPage: React.FC = () => {
  return (
    <>
      <OnboardingHeader />
      <OnboardingForm />
    </>
  );
};

export default MainPage;
